import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUser, useSession } from "../../services/SessionContext";

export function RequireAuth() {
  const { state } = useSession();
  const user = useCurrentUser();
  if (!user) return <Navigate to="/auth/sign-in" replace />;
  if (!user.emailVerified) return <Navigate to="/auth/verify-email" replace />;
  if (!state.currentCompanyId) return <Navigate to="/app/setup" replace />;
  return <Outlet />;
}

export function RequireSignedIn() {
  const user = useCurrentUser();
  if (!user) return <Navigate to="/auth/sign-in" replace />;
  return <Outlet />;
}
